import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import './font/montserrat/montserrat.css'
import './font/blackerdisplay/blackerdisplay.css'
import 'swiper/swiper-bundle.css'
import 'swiper/css/pagination'
import App from './App'
import IntlManager from './managers/IntManager'
import { ResponsiveProvider } from './utils/context/ResponsiveContext'
import AppThemeProvider from './components/theme/AppThemeProvider'
import { SelectionPaneProvider } from './components/selectionPane/components/SelectionPaneContext'
import RechercheProvider from './modules/resultats-recherche/utils/RechercheContext'
import { RechercheContactProvider } from './modules/rechercheContact/components/RechercheContactContext'
import { VisiteProvider } from './modules/planificationVisite/components/VisitesContext'
import { SnackBarProvider } from './components/snackBar/context/SnackBarContext'
import { QueryClientProvider, QueryClient } from '@tanstack/react-query'

const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
)
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false
		}
	}
})

root.render(
	<QueryClientProvider client={queryClient}>
		<IntlManager>
			<ResponsiveProvider>
				<AppThemeProvider>
					<SnackBarProvider>
						<RechercheProvider>
							<SelectionPaneProvider>
								<RechercheContactProvider>
									<VisiteProvider>
										<App />
									</VisiteProvider>
								</RechercheContactProvider>
							</SelectionPaneProvider>
						</RechercheProvider>
					</SnackBarProvider>
				</AppThemeProvider>
			</ResponsiveProvider>
		</IntlManager>
	</QueryClientProvider>
)